const numbro = require('numbro');

angular.module('wbFilters').filter('_percentage', () => {
  const percentFilter = (input, format) => {
    if (format == null) { format = "-0,0.00"; }
    if (!input || (`${input}`.length === 0) || isNaN(+input)) { return "-"; }
    if (_.isNumber(format)) {
      const precision = format;
      format = "-0,0";
      if (precision > 0) { format += "." + Array(precision + 1).join('0'); }
    }
    format += '%';
    return numbro(+input).format(format);
  };

  percentFilter.$stateful = true;
  return percentFilter;
});
